import React, { FC } from 'react'

import { DataResultMessage } from '../../DataResultMessage'
import * as S from './ErrorDataMessage.styles'

interface ErrorDataMessageProps {
  onTryAgain?: VoidFunction
  width?: string
}

export const ErrorDataMessage: FC<ErrorDataMessageProps> = ({ onTryAgain, width }) => {
  const errorConfig = {
    messageTitle: 'Oops, something went wrong.',
    message: "We couldn't load the info. Try to reload it again or try later.",
  }

  return (
    <S.ErrorWrapper width={width}>
      <DataResultMessage {...errorConfig} onTryAgain={onTryAgain} />
    </S.ErrorWrapper>
  )
}
